module.exports = __webpack_public_path__ + "static/media/mit_sports_lab_logo.f3584190.png";